/* unplugin-vue-components disabled */import { render } from "./testPieChart.vue?vue&type=template&id=1484b9ad&scoped=true"
import script from "./testPieChart.vue?vue&type=script&lang=js"
export * from "./testPieChart.vue?vue&type=script&lang=js"

import "./testPieChart.vue?vue&type=style&index=0&id=1484b9ad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1484b9ad"]])

export default __exports__